/**
 * `available`: a new version is waiting in this tab. `activated-elsewhere`: another tab applied it, so this
 * one runs the old code until the person reloads it — never reloaded for them, it may be in the middle of a
 * payment.
 */
export type PwaUpdateState = "none" | "available" | "activated-elsewhere";

type Listener = () => void;

let state: PwaUpdateState = "none";
let applyWaiting: (() => void) | null = null;
const listeners = new Set<Listener>();

function set(next: PwaUpdateState): void {
  if (state === next) return;
  state = next;
  listeners.forEach((listener) => listener());
}

export const pwaUpdateStore = {
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },

  getState(): PwaUpdateState {
    return state;
  },

  markAvailable(apply: () => void): void {
    applyWaiting = apply;
    if (state === "none") set("available");
  },

  markActivatedElsewhere(): void {
    set("activated-elsewhere");
  },

  apply(): void {
    if (state === "activated-elsewhere") window.location.reload();
    else applyWaiting?.();
  },
};
